export enum CandidateTab {
  OnGoingSession = "OnGoingSession",
  Results = "Results",
  Documents = "Documents",
  PersonalInfo = "PersonalInfo",
  Certificates = "Certificates",
}
